var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductionHouse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66669 10.0001H18.3334M1.66669 5.83341H5.83335M14.1667 5.83341H18.3334M1.66669 14.1667H5.83335M14.1667 14.1667H18.3334M5.83335 18.3334V1.66675M14.1667 18.3334V1.66675M5.66669 18.3334H14.3334C15.7335 18.3334 16.4336 18.3334 16.9683 18.0609C17.4387 17.8212 17.8212 17.4388 18.0609 16.9684C18.3334 16.4336 18.3334 15.7335 18.3334 14.3334V5.66675C18.3334 4.26662 18.3334 3.56655 18.0609 3.03177C17.8212 2.56137 17.4387 2.17892 16.9683 1.93923C16.4336 1.66675 15.7335 1.66675 14.3334 1.66675H5.66669C4.26656 1.66675 3.56649 1.66675 3.03171 1.93923C2.56131 2.17892 2.17885 2.56137 1.93917 3.03177C1.66669 3.56655 1.66669 4.26662 1.66669 5.66675V14.3334C1.66669 15.7335 1.66669 16.4336 1.93917 16.9684C2.17885 17.4388 2.56131 17.8212 3.03171 18.0609C3.56649 18.3334 4.26656 18.3334 5.66669 18.3334Z",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductionHouse);
export default __webpack_public_path__ + "static/media/production_house.5b471793a882a1c45e6a0ac2084b0bf5.svg";
export { ForwardRef as ReactComponent };